import MmenuLight from 'mmenu-light/esm/core/index';

window.addEventListener('DOMContentLoaded', () => {
    
    // mmenu Light
    // https://mmenujs.com/mmenu-light/docs.html
    function init_mmenu(){
        const mobile_menu = document.querySelector( "#mobile-menu" );
        if( mobile_menu ){
            const menu = new MmenuLight(
                document.querySelector( "#mobile-menu" ),
                "(max-width: 1280px)"
            );
            const navigator = menu.navigation({
                slidingSubmenus: false,
                title: "Menu",
                theme: "dark"
            });
            const drawer = menu.offcanvas({
                position: "right"
            });
            
            document.querySelector( 'a[href="#mobile-menu"]' ).addEventListener( 'click', function(e){
                e.preventDefault();
                drawer.open();
            });
        }
    }
    init_mmenu();


    class DropdownMenu{

        constructor( link ){
            this.item = link.closest('.menu-item-has-children');
            this.submenu = this.item.querySelector( '.sub-menu' );
            link.addEventListener( 'mouseenter', this.show_menu.bind(this) );
            this.item.addEventListener( 'mouseleave', this.hide_menu.bind(this) );
        }

        show_menu(e){
            this.submenu.style.display = "flex";
            setTimeout( () => this.submenu.classList.add('visible'), 10 );
        }
        
        hide_menu(e){
            this.submenu.classList.remove("visible");
            setTimeout( () => this.submenu.style.display = "none", 300 );
        }
    }

    // Dropdown menu
    const dropdowns = document.querySelectorAll('.main-menu .menu > .menu-item-has-children > a');

    if(dropdowns){
        dropdowns.forEach( item => new DropdownMenu(item))
    }

});
